import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';
import { DefaultArg, DefaultApiResponse } from '@libs/graphql';

import { RealFiatAssets } from '@libs/types';

export type payWithWalletArgs = {
  amount: number;
  asset: RealFiatAssets;
};

export type PayWithWalletResponse = {
  payWithWallet: DefaultApiResponse<{ token: string }>;
};

export const payWithWalletMutation: TypedDocumentNode<
  PayWithWalletResponse,
  DefaultArg<payWithWalletArgs>
> = gql`
  mutation payWithWallet($record: WalletPaymentRecord!) {
    payWithWallet(record: $record) {
      token
    }
  }
`;
